import { module } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const KEY = 'popular'

export const Popular: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, module)
}
